export default {
  buybackSwapSummaryPriceNew: {
    id: 'buyback_swap_summary_price_new',
    defaultMessage: 'Buyback of {price}',
  },
  buybackSwapSummaryDelete: {
    id: 'buyback_swap_summary_delete',
    defaultMessage: 'Delete my buyback',
  },
  buybackSwapSummaryTitle: {
    id: 'buyback_swap_summary_title',
    defaultMessage: 'About the buyback',
  },
  buybackSwapSummaryTradeInValue: {
    id: 'cart_swap_trade_in_value',
    defaultMessage: 'Trade-in value: {price}',
  },
  buybackSwapSummaryTradeInRemove: {
    id: 'cart_swap_trade_in_remove',
    defaultMessage: 'Remove',
  },
  buybackSwapSummaryTradeInShipping: {
    id: 'cart_swap_ship_instruction',
    defaultMessage: 'Ship within 21 days of trade-in offer.',
  },
  buybackSwapSummaryTradeMailing: {
    id: 'cart_swap_kit_instruction',
    defaultMessage: 'Receive free mailing kit within 4 days.',
  },
  buybackSwapSummaryTradeMailingQrCode: {
    id: 'cart_swap_qr_code_instruction',
    defaultMessage: 'Free and easy to ship.',
  },
  buybackSwapSummaryTradeNoMailing: {
    id: 'cart_swap_label_instruction',
    defaultMessage: 'Download your free shipping label.',
  },
  buybackSwapSummaryTradeInMoney: {
    id: 'cart_swap_get_paid_instruction',
    defaultMessage: 'Get paid after inspection.',
  },
  buybackSwapSummaryTradeInLearnMore: {
    id: 'cart_swap_trade_in_learn_more',
    defaultMessage: 'Learn more',
  },
  buybackSwapSummaryTradeInBestOffer: {
    id: 'swap_cart_tag_price',
    defaultMessage: 'Highest offer in 7 days',
  },
  buybackSwapSummaryTradeInTrades: {
    id: 'swap_cart_tag_trades',
    defaultMessage: '9,500 traded in last week',
  },
}
